import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TokenStore } from './+state/token.store';

export function provideToken(): EnvironmentProviders {
  return makeEnvironmentProviders([TokenStore]);
}
